import type { IMenuItem } from '~/types/site/menu';

export const CABINET_URL = '/cabinet/';

export const MENU_ITEMS: IMenuItem[] = [
  {
    id: 'account',
    text: 'Мой профиль',
    linkUrl: '/cabinet/account/',
    icon: 'ArrowRight16',
  },
];
